import React, { Component } from "react"
import intl from "react-intl-universal"
import { Select, Button, Input, Modal, Form, notification } from "antd"
import { LanguageMap, TimezoneMap, PhoneCode } from "../../common/data"
import { editProfile, passwordReset } from "../../../api/user/profile"
const { Option } = Select

class Profile extends Component {
  formRef = React.createRef()
  formRefPhone = React.createRef()
  formRefEmail = React.createRef()
  
  state = {
    editFlag: false,
    userId: global.userInfo.userId,
    profile: {
      nickname: global.userInfo.nickname,
      language: global.userInfo.language,
      timezone: global.userInfo.timezone,
      time: global.userInfo.created_at,
      email: global.userInfo.email,
      phone: global.userInfo.phone,
    },
    newProfile: {},
    isShowModel: false,
    isShowModelPhone: false,
    isShowModelEmail: false,
  }

  handleEdit = () => {
    this.setState({
      newProfile: {
        ...this.state.profile
      },
      editFlag: true
    })
  }
  handleCancel = () => {
    this.setState({
      newProfile: {
        ...this.state.profile
      },
      editFlag: false
    })
  }
  handleSave = () => {
    let that = this;
    let params = {
      id: this.state.userId, 
      nickname: this.state.newProfile.nickname,
      language: this.state.newProfile.language,
      timezone: this.state.newProfile.timezone
    };
    editProfile(params).then((res) => {
      if (res.code === 0) {
          that.setState({
            profile: {
              ...that.state.newProfile
            },
            editFlag: false
          })
      }
    }, (error) => {})
  }
  handleProfileNickname = (e) => {
    this.setState({
      newProfile: {
        ...this.state.newProfile,
        nickname: e.target.value
      }
    })
  }
  handleProfileLanguage = (value) => {
    this.setState({
      newProfile: {
        ...this.state.newProfile,
        language: value
      }
    })
  }
  handleProfileTimezone = (value) => {
    this.setState({
      newProfile: {
        ...this.state.newProfile,
        timezone: value
      }
    })
  }
  showModal = (value) => {
    this.setState({
      isShowModel: true
    })
  }
  handleModalCancel = (value) => {
    this.setState({
      isShowModel: false
    })
    this.formRef.current.resetFields()
  }
  onFinish = (values) => {
    let that  = this;
    let params = {
      id: this.state.userId, 
      oldPassword: values.old_password, 
      password: values.new_password
    };
    passwordReset(params).then((res) => {
      if (res.code === 0 && res.data) {
        notification.success({
          message: 'Success',
          description: intl.get('user.pwd_edit_success'),
        })
        that.setState({
          isShowModel: false
        })
        that.formRef.current.resetFields()
      } else {
        notification.error({
          message: 'Error',
          description: intl.get('user.old_pwd_input_error'),
        })
      }
    }, (error) => {})
  }
  showModalPhone = (value) => {
    this.setState({
      isShowModelPhone: true
    })
  }
  handleModalCancelPhone = (value) => {
    this.setState({
      isShowModelPhone: false
    })
    this.formRefPhone.current.resetFields()
  }
  onFinishPhone = (values) => {
    let that = this
    let newPhone = values.phone_code + ' ' + values.new_phone
    let params = {
      id: this.state.userId, 
      phone: newPhone
    };
    editProfile(params).then((res) => {
      if (res.code === 0 && res.data) {
        notification.success({
          message: 'Success',
          description: intl.get('user.phone_edit_success'),
        })
        that.setState({
          profile: {
            ...this.state.profile,
            phone: newPhone
          },
          isShowModelPhone: false
        })
        that.formRefPhone.current.resetFields()
      } else {
        notification.error({
          message: 'Error',
          description: intl.get('user.phone_edit_fail'),
        })
      }
    }, (error) => {})
  }
  showModalEmail = (value) => {
    this.setState({
      isShowModelEmail: true
    })
  }
  handleModalCancelEmail = (value) => {
    this.setState({
      isShowModelEmail: false
    })
    this.formRefEmail.current.resetFields()
  }
  onFinishEmail = (values) => {
    let that = this;
    let params = {
      id: this.state.userId, 
      email: values.new_email
    };
    editProfile(params).then((res) => {
      if (res.code === 0 && res.data) {
        notification.success({
          message: 'Success',
          description: intl.get('user.email_edit_success'),
        })
        that.setState({
          profile: {
            ...this.state.profile,
            email: values.new_email
          },
          isShowModelEmail: false
        })
        that.formRefEmail.current.resetFields()
      } else {
        notification.error({
          message: 'Error',
          description: intl.get('user.email_edit_fail'),
        })
      }
    }, (error) => {})
  }
  validatorNewPassword = (rule, value) => {
    let reg = /^(?=.*[A-Za-z])(?=.*\d)[\S]{8,}$/
    if (value && (value.length >= 8) && !reg.test(value)) {
      return Promise.reject(intl.get('user.email_validator'))
    } else {
      return Promise.resolve()
    }
  }

  render () {
    return (
      <div>
        <div className="welcome" style={{ height: '64px' }}>
          <div className="d-flex align-items-center px-4 w-100">
            <div className="font-20-l28">
              {intl.get('user.profile')}
            </div>
          </div>
        </div>
        <div className="content" style={{ padding: '16px 20px' }}>
          {/* 基本信息 */}
          <div className="bg-white mb-3">
            <div className="a-card-header d-flex justify-content-between align-items-center"
              style={{ padding: '11px 24px', height: '56px' }}>
              <div className="font-16-l24">{intl.get('user.my_profile')}</div>
              <div className={this.state.editFlag ? 'd-none' : ''}>
                <Button type="primary" onClick={this.handleEdit}>{intl.get('user.edit_profile')}</Button>
              </div>
            </div>
            {/* 基本信息 */}
            <div className={this.state.editFlag ? 'd-none px-4 py-2' : 'px-4 py-2'}>
              <div className="d-flex align-items-center profile-content">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.user_name')}</div>
                <div className="font-14-l22-w400-v85">{this.state.profile.nickname}</div>
              </div>
              <div className="d-flex align-items-center profile-content">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.language')}</div>
                <div className="font-14-l22-w400-v85">{LanguageMap(this.state.profile.language)}</div>
              </div>
              <div className="d-flex align-items-center profile-content">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.timezone')}</div>
                <div className="font-14-l22-w400-v85">{this.state.profile.timezone}</div>
              </div>
              <div className="d-flex align-items-center profile-content">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.registration_time')}</div>
                <div className="font-14-l22-w400-v85">{this.state.profile.time}</div>
              </div>
            </div>
            {/* 基本信息-编辑 */}
            <div className={this.state.editFlag ? 'px-4 py-2' : 'px-4 py-2 d-none'}>
              <div className="d-flex align-items-center py-2">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.user_name')}</div>
                <div className="font-14-l22-w400-v85">
                  <Input
                    value={this.state.newProfile.nickname}
                    style={{
                      width: 316,
                    }}
                    onChange={this.handleProfileNickname} />
                </div>
              </div>
              <div className="d-flex align-items-center py-2">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.language')}</div>
                <div className="font-14-l22-w400-v85">
                  <Select
                    showSearch
                    optionFilterProp="children"
                    value={this.state.newProfile.language}
                    style={{
                      width: 316,
                    }}
                    onChange={this.handleProfileLanguage}>
                    {
                      LanguageMap().map((item, idx) => (<Option key={idx} value={item.value}>{item.label}</Option>))
                    }
                  </Select>
                </div>
              </div>
              <div className="d-flex align-items-center py-2">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.timezone')}</div>
                <div className="font-14-l22-w400-v85">
                  <Select
                    showSearch
                    optionFilterProp="children"
                    value={this.state.newProfile.timezone}
                    style={{
                      width: 316,
                    }}
                    onChange={this.handleProfileTimezone}>
                    {
                      TimezoneMap().map((item, idx) => (<Option key={idx} value={item.value}>{item.label}</Option>))
                    }
                  </Select>
                </div>
              </div>
              <div className="d-flex align-items-center profile-content">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.registration_time')}</div>
                <div className="font-14-l22-w400-v85">{this.state.newProfile.time}</div>
              </div>
              <div className="profile-border-top mt-2 pt-3 pb-2">
                <Button type="primary" onClick={this.handleSave}>{intl.get('sys.save')}</Button>
                <Button style={{ marginLeft: '8px' }} onClick={this.handleCancel}>{intl.get('sys.cancel')}</Button>
              </div>
            </div>

          </div>
          {/* 账号安全 */}
          <div className="bg-white mb-3">
            <div className="a-card-header d-flex justify-content-between align-items-center"
              style={{ padding: '16px 24px', height: '56px' }}>
              <div className="font-16-l24">{intl.get('user.account_security')}</div>
            </div>

            <div className="px-4 font-14-l22">
              <div className="d-flex align-items-center profile-content2 position-relative profile-border-bottom">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.email')}</div>
                <div className="font-14-l22-w400-v85">{this.state.profile.email}</div>
                <div className="position-absolute font-14-l22"
                  style={{ color: '#1890FF', right: '0', cursor: 'pointer' }}
                  onClick={this.showModalEmail}>{intl.get('sys.edit')}</div>
              </div>
              <div className="d-flex align-items-center profile-content2 position-relative profile-border-bottom">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.phone')}</div>
                <div className="font-14-l22-w400-v85">{this.state.profile.phone}</div>
                <div className="position-absolute font-14-l22"
                  style={{ color: '#1890FF', right: '0', cursor: 'pointer' }}
                  onClick={this.showModalPhone}>{intl.get('sys.edit')}</div>
              </div>
              <div className="d-flex align-items-center profile-content2 position-relative">
                <div className="profile-thead font-14-l22-w400">{intl.get('user.password')}</div>
                <div className="font-14-l22-w400-v85">********</div>
                <div className="position-absolute font-14-l22"
                  style={{ color: '#1890FF', right: '0', cursor: 'pointer' }}
                  onClick={this.showModal}>{intl.get('sys.edit')}</div>
              </div>
            </div>

          </div>
        </div>
        {/* 邮箱-编辑 */}
        <Modal
          transitionName=""
          maskTransitionName=""
          title={intl.get('sys.edit_email')}
          visible={this.state.isShowModelEmail}
          onCancel={this.handleModalCancelEmail}
          footer={null}>
          <Form
            ref={this.formRefEmail}
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 20,
            }}
            onFinish={this.onFinishEmail}
            autoComplete="off">
            <Form.Item
              label={intl.get('user.new_email')}
              name="new_email"
              rules={[
                {
                  required: true,
                  message: intl.get('sys.required_msg'),
                },
                {
                  type: 'email',
                  message: intl.get('user.email_input_error'),
                },
              ]}>
              <Input placeholder={intl.get('user.bind_new_email')} />
            </Form.Item>
            <Form.Item className="mt-3">
              <Button type="primary" htmlType="submit">
                {intl.get('sys.save')}
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        {/* 手机号-编辑 */}
        <Modal
          transitionName=""
          maskTransitionName=""
          title={intl.get('sys.edit_phone')}
          visible={this.state.isShowModelPhone}
          onCancel={this.handleModalCancelPhone}
          footer={null}>
          <Form
            ref={this.formRefPhone}
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 20,
            }}
            onFinish={this.onFinishPhone}
            autoComplete="off">
            <Form.Item
              label={intl.get('user.new_phone')}>
              <Input.Group compact>
                <Form.Item
                  name='phone_code'
                  initialValue="+86"
                  noStyle >
                  <Select
                    style={{
                      width: '90px'
                    }}
                    showSearch
                    optionFilterProp="children"
                    optionLabelProp="label" 
                    dropdownMatchSelectWidth={false}>
                    {
                      PhoneCode().map((item, idx) => (<Option key={idx} value={item.code} label={item.code}>{item.label + ' (' + item.code + ')'}</Option>))
                    }
                  </Select>
                </Form.Item>
                <Form.Item
                  name="new_phone"
                  noStyle
                  rules={[
                    {
                      required: true,
                      message: intl.get('sys.required_msg'),
                    },
                    {
                      validator: (rule, value) => {
                        let reg = /^[0-9 ]{1,}$/
                        if (value && !reg.test(value)) {
                          return Promise.reject(intl.get('user.phone_validator'))
                        } else {
                          return Promise.resolve()
                        }
                      }
                    }
                  ]}
                >
                  <Input
                    style={{
                      width: '50%'
                    }}
                    placeholder={intl.get('user.bind_new_phone')} />
                </Form.Item>
              </Input.Group>
            </Form.Item>
            <Form.Item className="mt-3">
              <Button type="primary" htmlType="submit">
                {intl.get('sys.save')}
              </Button>
            </Form.Item>
          </Form>
        </Modal>
        {/* 密码-编辑 */}
        <Modal
          transitionName=""
          maskTransitionName=""
          title={intl.get('sys.edit_password')}
          visible={this.state.isShowModel}
          onCancel={this.handleModalCancel}
          footer={null}>
          <Form
            name="pwd"
            ref={this.formRef}
            labelCol={{
              span: 4,
            }}
            wrapperCol={{
              span: 20,
            }}
            onFinish={this.onFinish}
            autoComplete="off">
            <Form.Item
              label={intl.get('user.old_password')}
              name="old_password"
              rules={[
                {
                  required: true,
                  message: intl.get('sys.required_msg'),
                }
              ]}>
              <Input.Password />
            </Form.Item>
            <Form.Item
              label={intl.get('user.new_password')}
              name="new_password"
              rules={[
                {
                  required: true,
                  message: intl.get('sys.required_msg'),
                },
                {
                  min: 8,
                  message: intl.get('user.password_validator'),
                },
                {
                  validator: this.validatorNewPassword
                }
              ]}>
              <Input.Password />
            </Form.Item>
            <Form.Item
              label={intl.get('user.confirm_password')}
              name="password_confirm"
              rules={[
                {
                  required: true,
                  message: intl.get('sys.required_msg'),
                },
                ({ getFieldValue }) => ({
                  validator (rule, value) {
                    if (value && getFieldValue('new_password') !== value) {
                      return Promise.reject(intl.get('user.confirm_password_validator'))
                    }
                    return Promise.resolve()
                  },
                })
              ]}>
              <Input.Password />
            </Form.Item>
            <Form.Item className="mt-3">
              <Button type="primary" htmlType="submit">
                {intl.get('sys.save')}
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default Profile
